/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ScheduleQueryResultOrg from './ScheduleQueryResultOrg';
import ScheduleQueryResultUser from './ScheduleQueryResultUser';

/**
 * The ScheduleQueryResult model module.
 * @module model/ScheduleQueryResult
 * @version 1.0
 */
class ScheduleQueryResult {
    /**
     * Constructs a new <code>ScheduleQueryResult</code>.
     * @alias module:model/ScheduleQueryResult
     */
    constructor() { 
        
        ScheduleQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ScheduleQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ScheduleQueryResult} obj Optional instance to populate.
     * @return {module:model/ScheduleQueryResult} The populated <code>ScheduleQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ScheduleQueryResult();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('org')) {
                obj['org'] = ScheduleQueryResultOrg.constructFromObject(data['org']);
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = ScheduleQueryResultUser.constructFromObject(data['user']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
ScheduleQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} date
 */
ScheduleQueryResult.prototype['date'] = undefined;

/**
 * @member {String} deletedAt
 */
ScheduleQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
ScheduleQueryResult.prototype['id'] = undefined;

/**
 * @member {module:model/ScheduleQueryResultOrg} org
 */
ScheduleQueryResult.prototype['org'] = undefined;

/**
 * @member {String} updatedAt
 */
ScheduleQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {module:model/ScheduleQueryResultUser} user
 */
ScheduleQueryResult.prototype['user'] = undefined;






export default ScheduleQueryResult;

